var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      [
        _c("div", [
          _c(
            "table",
            { staticClass: "table" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                _setup.draggable,
                {
                  attrs: { tag: "tbody", handle: ".handle", animation: 150 },
                  on: { end: _setup.onEnd },
                  model: {
                    value: _setup.options,
                    callback: function ($$v) {
                      _setup.options = $$v
                    },
                    expression: "options",
                  },
                },
                [
                  _vm._l(_setup.options, function (option, index) {
                    return _c(
                      "tr",
                      {
                        key: option.value || index,
                        staticClass: "visible-on-hover",
                      },
                      [
                        _c(
                          "td",
                          {
                            staticClass: "handle",
                            staticStyle: { cursor: "grab" },
                          },
                          [_vm._v("⋮⋮")]
                        ),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(option.value))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(option.text))]),
                        _vm._v(" "),
                        _c("td", [
                          _c("small", {
                            staticClass: "bi-trash3 cursor-pointer text-danger",
                            on: {
                              click: function ($event) {
                                return _setup.removeOption(index)
                              },
                            },
                          }),
                        ]),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  !_setup.options || !_setup.options.length
                    ? _c("tr", { attrs: { slot: "footer" }, slot: "footer" }, [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "4" },
                          },
                          [
                            _c("em", { staticClass: "text-muted" }, [
                              _vm._v("No options configured."),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ],
      _vm._v(" "),
      _c("div", { staticClass: "mt-1" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_setup.formIsShown,
                expression: "!formIsShown",
              },
            ],
            ref: "addOptionBtn",
            staticClass: "btn btn-light btn-sm",
            attrs: { type: "button" },
            on: { click: _setup.showForm },
          },
          [
            _c("i", { staticClass: "bi-plus-lg" }),
            _vm._v(" Add Option\n        "),
          ]
        ),
        _vm._v(" "),
        _setup.formIsShown
          ? _c(
              "form",
              {
                staticClass: "row gy-2 gx-3 align-items-center",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _setup.addOption.apply(null, arguments)
                  },
                },
              },
              [
                _c("div", { staticClass: "col-auto" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _setup.formData.value,
                        expression: "formData.value",
                      },
                    ],
                    ref: "valueInput",
                    staticClass: "form-control form-control-sm",
                    class: { "is-invalid": _setup.errorValue },
                    attrs: { placeholder: "Value", type: "text" },
                    domProps: { value: _setup.formData.value },
                    on: {
                      keyup: _setup.valueInputKeyup,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_setup.formData, "value", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "invalid-feedback" }, [
                    _c("span", [_vm._v(_vm._s(_setup.errorValue || " "))]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-auto" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _setup.formData.text,
                        expression: "formData.text",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    class: { "is-invalid": _setup.errorText },
                    attrs: { placeholder: "Text", type: "text" },
                    domProps: { value: _setup.formData.text },
                    on: {
                      keyup: _setup.textInputKeyup,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_setup.formData, "text", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "invalid-feedback" }, [
                    _c("span", [_vm._v(_vm._s(_setup.errorText || " "))]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-auto" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm me-1",
                      attrs: {
                        disabled: !!_setup.errorValue || !_setup.formData.value,
                        type: "submit",
                      },
                    },
                    [_vm._v("\n                    Save\n                ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light btn-sm",
                      attrs: { type: "button" },
                      on: { click: _setup.hideForm },
                    },
                    [_vm._v("\n                    Cancel\n                ")]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "2.5rem" } }),
        _vm._v(" "),
        _c("th", [_vm._v("Value")]),
        _vm._v(" "),
        _c("th", [_vm._v("Text")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "3rem" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }